var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 7.33334C10.0833 6.82708 10.4937 6.41668 11 6.41668C11.5063 6.41668 11.9167 6.82708 11.9167 7.33334C11.9167 7.8396 11.5063 8.25001 11 8.25001C10.4937 8.25001 10.0833 7.8396 10.0833 7.33334ZM10.0833 11C10.0833 10.4937 10.4937 10.0833 11 10.0833C11.5063 10.0833 11.9167 10.4937 11.9167 11V14.6667C11.9167 15.1729 11.5063 15.5833 11 15.5833C10.4937 15.5833 10.0833 15.1729 10.0833 14.6667V11ZM11 1.83334C5.94001 1.83334 1.83334 5.94001 1.83334 11C1.83334 16.06 5.94001 20.1667 11 20.1667C16.06 20.1667 20.1667 16.06 20.1667 11C20.1667 5.94001 16.06 1.83334 11 1.83334ZM11 18.3333C6.95751 18.3333 3.66668 15.0425 3.66668 11C3.66668 6.95751 6.95751 3.66668 11 3.66668C15.0425 3.66668 18.3333 6.95751 18.3333 11C18.3333 15.0425 15.0425 18.3333 11 18.3333Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.e31638acaad1884d2ca077b13a417abe.svg";
export { ForwardRef as ReactComponent };